// ============================================================================
// attachmentLabels — legende d'une piece jointe (« PDF · 1,2 Mo »)
// ============================================================================
// Partagee par la liste de l'editeur et le rendu dans le telephone. Le genre
// et l'unite de taille passent par les cles i18n, jamais ecrits en dur.

import type { TFunction } from 'i18next';
import { formatSize, type AttachmentKind, type AttachmentView } from './piecesJointes';

export function kindLabel(kind: AttachmentKind, t: TFunction): string {
  if (kind === 'image') return t('gest:accueil.editor.files.kindImage');
  if (kind === 'pdf') return t('gest:accueil.editor.files.kindPdf');
  return t('gest:accueil.editor.files.kindPptx');
}

export function sizeLabel(bytes: number, locale: string, t: TFunction): string {
  const { amount, unit } = formatSize(bytes, locale);
  return unit === 'kb'
    ? t('gest:accueil.editor.files.sizeKb', { size: amount })
    : t('gest:accueil.editor.files.sizeMb', { size: amount });
}

export function attachmentMeta(a: AttachmentView, locale: string, t: TFunction): string {
  return t('gest:accueil.editor.files.meta', { kind: kindLabel(a.kind, t), size: sizeLabel(a.size, locale, t) });
}
